import { DATA_CLASSIFICATION_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

export const transformAggDataClassificationToLegacyField: FieldTransformer = (node) => ({
	...transformAggNodeToLegacyField(node),
	key: DATA_CLASSIFICATION_TYPE,
	value: node,
	schema: {
		configuration: null,
		items: null,
		renderer: null,
		custom: null,
		system: null,
		type: DATA_CLASSIFICATION_TYPE,
	},
});
